function DesignedForPractice() {
  return (
<section className="dfrp">
      <div className="dfrp-hdr">
        <div className="eyebrow rv">
          <div className="eyebrow-dash"></div>
          <span className="eyebrow-text" style={{ color: "#a6a39b" }}
            >How We're Different</span
          >
        </div>
        <h2 className="sec-title lt rv d1">Designed for <em>Real Practice</em></h2>
        <p className="dfrp-sub rv d2">
          Not theory. Not lectures alone. A curriculum built around the tools,
          workflows, and pressures of an actual design firm.
        </p>
      </div>
      <div className="dfrp-grid rv d3">
        <div className="dfrp-item">
          <div className="dfrp-n">01</div>
          <div className="dfrp-t">Live Industry Briefs</div>
          <p className="dfrp-d">
            Work on real project briefs sourced directly from partner firms, not
            hypothetical case studies.
          </p>
        </div>
        <div className="dfrp-item">
          <div className="dfrp-n">02</div>
          <div className="dfrp-t">Studio-Style Mentorship</div>
          <p className="dfrp-d">
            Small batches, reviewed by practicing architects the way a senior
            partner reviews junior work.
          </p>
        </div>
        <div className="dfrp-item">
          <div className="dfrp-n">03</div>
          <div className="dfrp-t">Tools Firms Actually Use</div>
          <p className="dfrp-d">
            Revit, BIM, Rhino — the exact software stack you'll be
            expected to know on day one.
          </p>
        </div>
        <div className="dfrp-item">
          <div className="dfrp-n">04</div>
          <div className="dfrp-t">Outcome-Led Design</div>
          <p className="dfrp-d">
            Every module maps to a placement-ready skill, not just a grade on a
            transcript.
          </p>
        </div>
      </div>
    </section>
  );
}

export default DesignedForPractice;
